import api from './api';

export const encaixarAgendaApi = async (agendaItem, dateAgendaFormatted) => {
  await api.post('/agenda', {
    CODPAC: 1,
    CODCONV: 1000,
    CODPROCEDI: 1000,
    CODMEDICO: agendaItem.CODMED,
    HORARIO: agendaItem.HORARIO + 1,
    DATAAGENDA: dateAgendaFormatted,
    ESTADO: 'Marcada',
    ATIVIDADE: agendaItem.ATIVIDADE,
    OBS: '',
  });
};

export const updateAgendaSituacaoApi = async (codAgenda, situacao) => {
  await api.put('/agenda/situacao', {
    CODAGENDA: codAgenda,
    SITUACAO: situacao,
  });
};

export const registrarPacienteFaltouApi = async pAgenda => {
  await api.post(`/paciente/${pAgenda.CODPAC}/observacao`, {
    obs: `Faltou dia ${pAgenda.dataFormatada} - ${pAgenda.PROCEDIMENTO} - Dr. ${pAgenda.NOMEMED}`,
  });
};
